import { Skeleton } from "@mui/material";
import "./Skeleton.css";

const DeckLoader = ({ count }) => {
  const safeCount = Number(count);
  return [...Array(safeCount)].map((_, i) => (
    <div key={`deck-loader-${i}`} className="deck-skeleton">
      <div className="row">
        <div className="child">
          <Skeleton
            variant="text"
            height={40}
            sx={{ fontSize: "2rem", width: "15rem" }}
          />
          <Skeleton
            variant="text"
            sx={{ fontSize: "1rem", width: "8rem" }}
            height={20}
          />
        </div>
        <div className="child">
          <Skeleton variant="circular" width={30} height={30} />
        </div>
      </div>
      <div className="row">
        <div className="child side-by-side">
          <Skeleton
            variant="text"
            sx={{ fontSize: "1rem", width: "5rem" }}
            height={15}
          />
          <Skeleton
            variant="text"
            sx={{ fontSize: "1rem", width: "5rem" }}
            height={15}
          />
        </div>
        <div className="child">
          <Skeleton variant="circular" width={30} height={30} />
        </div>
      </div>
    </div>
  ));
};

const CategoryLoader = ({ count }) => {
  const safeCount = Number(count);
  return [...Array(safeCount)].map((_, i) => (
    <div key={`cat-loader-${i}`} className="my-5 cat-loader">
      <div className="row">
        <div className="child">
          <Skeleton
            variant="text"
            height={40}
            sx={{ fontSize: "2rem", maxWidth: "35rem", marginBottom: "0.5rem" }}
          />
        </div>
        <div className="child">
          <Skeleton variant="circular" width={30} height={30} />
        </div>
      </div>
      <div className="skeleton-deck-group">
        {" "}
        <DeckLoader count={3} />
      </div>
    </div>
  ));
};

export default CategoryLoader;
